import { IDamageReportReducer } from '../../../reducers/damageReportReducer';

export const getEmailSentTo = (damageReportReducer: IDamageReportReducer) => {
	const { stepInfoAboutDamage, stepInfo } = damageReportReducer;
	const { whoFillsOut } = stepInfoAboutDamage;
	if (whoFillsOut) {
		if (whoFillsOut.value === 'sender') {
			return stepInfo.senderEmail;
		}
		if (whoFillsOut.value === 'recipient') {
			return stepInfo.receiverEmail;
		}
		if (whoFillsOut.value === 'employee' || whoFillsOut.value === 'other') {
			return stepInfoAboutDamage.emailForCopyOfReport;
		}
		return '';
	}
	return null;
};
